import React from 'react';
import RotatingText from './RotatingText';

function Hero() {
  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/assest/img/Hero.jpg)`
  };

  const rotatingPhrases = [
    "Connecting Communities",
    "Empowering Innovation",
    "Empowering Dreams"
  ];

  return (
    <section className="hero" style={heroStyle}>
      <div className="hero-overlay" />
      <div className="hero-container">
        <h1 className="hero-title">THE HUB OF HUBS</h1>
        <RotatingText 
          phrases={rotatingPhrases} 
          interval={4000}
          className="hero-rotating-text"
        />
        <div className="hero-cta">
        </div>
      </div>
    </section>
  );
}

export default Hero;


